<template>
  <InsideContent
    class="campaign-overall"
    :title="$t('ADVERTISEMENT.STATS.CAMPAIGN.TITLE')"
  >
    <Card>
      <div class="row campaign-overall__header">
        <div class="columns">
          <div class="columns large-3">
            <RangeFilter v-model="range" />
          </div>
        </div>
        <div class="columns shrink">
          <StrokeButton plain size="small" type="primary" @click="getCSV">
            {{ $t('EXPORT_CSV') }}
          </StrokeButton>
        </div>
      </div>
      <CampaignOverallCharts :range="range" />
    </Card>
  </InsideContent>
</template>

<script>
import RangeFilter from '@@/common/RangeFilter';
import chart from '@/mixins/chart';
import statsFilter from '@/mixins/statsFilter';
import CampaignOverallCharts from './CampaignOverallCharts';
import InsideContent from '@@/common/layout/InsideContent';

import StrokeButton from '../../../common/StrokeButton';

import Card from '@@/common/Card';
import { AdInsight } from '@/api/api';
import campaignId from '@/mixins/advertisement/campaignId';

import FileSaver from 'file-saver';

export default {
  name: 'CampaignOverall',

  components: {
    RangeFilter,
    Card,
    CampaignOverallCharts,
    InsideContent,
    StrokeButton,
  },

  mixins: [chart, statsFilter, campaignId],

  data() {
    return {
      range: 'last-week',
    };
  },

  methods: {
    updateRange(range) {
      this.range = range;
    },
    getCSV() {
      return AdInsight.saveOverallCSV(this.campaignId, this.range).then(
        file => {
          FileSaver.saveAs(file, file.name);
        },
      );
    },
  },
};
</script>
<style lang="scss">
.campaign-overall {
  &__header {
    margin-bottom: $global-margin * 2;
  }
}
</style>
